import React from 'react';

import './PoE2Leveling.sass';

import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class PoE2Leveling1To100RankPicker extends React.PureComponent {
  static describeRank = rank => rank.toString();

  static minValue = 1;
  static maxValue = 100;

  static getDefaultValue = () => [1, 75];

  static marks = {
    1: '1',
    10: '10',
    20: '20',
    30: '30',
    40: '40',
    50: '50',
    60: '60',
    70: '70',
    80: '80',
    90: '90',
    100: '100'
  };

  render() {
    const {intl, collapsed, value, onChange} = this.props;

    return (
      <div>
        <div className="range-inputs">
          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.level'})}
              min={PoE2Leveling1To100RankPicker.minValue}
              max={PoE2Leveling1To100RankPicker.maxValue}
              value={value[0]}
              onChange={newValue => onChange([
                newValue,
                value[1]
              ])}
            />
          </div>

          <div className="range-inputs__divider"/>

          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.wanted'})}
              min={PoE2Leveling1To100RankPicker.minValue}
              max={PoE2Leveling1To100RankPicker.maxValue}
              value={value[1]}
              onChange={newValue => onChange([
                value[0],
                newValue
              ])}
            />
          </div>
        </div>

        {!collapsed && (
          <div className="slider">
            <VariableStepRange
              className="rc-slider-poe2-leveling"
              step={1}
              min={PoE2Leveling1To100RankPicker.minValue}
              max={PoE2Leveling1To100RankPicker.maxValue}
              marks={PoE2Leveling1To100RankPicker.marks}
              value={value}
              onChange={onChange}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/poe2/PoE2Leveling1To100RankPicker.js